<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="calendar-card">
    <div class="calendar-date">
      <div class="date-wrap">
        <div class="date">{{ computedDate }}</div>
        <div v-if="card.hour" class="date-hour">{{ card.hour }}</div>
      </div>
      <div v-if="isMobile" class="calendar-add">
        <div v-if="card.new" class="cal-tag-op">
          <div class="new-icon" />
          <div>{{ $t('new') }}</div>
        </div>
        <div v-if="card.late && card.delayReason" v-tooltip="card.delayReason" class="cal-tag-op c-pointer">
          <div class="time-icon" />
          <div>{{ $t('retard') }}</div>
        </div>
      </div>
    </div>
    <div class="calendar-desc">
      <!-- <div :class="'icon-' + card.source" /> -->
      <ItemIcon :type="card.source" size="sm" :filled="false" />
      <div class="cal-inf">
        <div class="card-title">{{ card.title }}</div>
        <div v-if="seeMoreOpen" class="card-see-extra">
          <div v-cms="card.subtitle" class="card-subtitle" />
          <div v-if="card.relatedUrl" class="calendar-url">
            <a :href="card.relatedUrl"><span>{{ card.relatedUrl }}</span></a>
          </div>
        </div>
        <div class="pub-op-wrap">
          <div class="pub-op" @click="toggleSeeOpen">{{ seeMoreOpen ? $t('show_less') : $t('show_more') }}</div>
          <div v-if="!hasPassed" class="pub-op" @click="downloadEvent(card)">{{ $t('add_to_calendar') }}</div>
        </div>
      </div>
    </div>
    <div v-if="!isMobile" class="calendar-add">
      <div v-if="card.new" class="cal-tag-op">
        <div class="new-icon" />
        <div>{{ $t('new') }}</div>
      </div>
      <div v-if="card.late && card.delayReason" v-tooltip="card.delayReason" class="cal-tag-op c-pointer">
        <div class="time-icon" />
        <div>{{ $t('retard') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { t } from '@/i18n'
import dayjs from 'dayjs'
import ItemIcon from '../ItemIcon.vue'
import Vue from 'vue'
import ICS from 'vue-ics'
import { vCmsHtml as cms } from '@/services/graphql'

var advancedFormat = require('dayjs/plugin/advancedFormat')
dayjs.extend(advancedFormat)

Vue.use(ICS)

export default {
  components: { ItemIcon },
  directives: { cms },
  props: {
    card: {
      type: Object,
    },
  },
  data() {
    return {
      seeMoreOpen: false,
    }
  },
  computed: {
    computedDate() {
      return this.card ? dayjs(this.card.dates).format('D MMM') : null
    },
    hasPassed() {
      return dayjs(this.card.dates).format('x') > dayjs(new Date ()).format('x') ? false : true
    }
  },
  asyncComputed: {},
  watch: {},
  methods: {
    downloadEvent(card) {
      let language = this.$store.state.i18n.lang
      let subject = card.title
      let description = card.subtitle
      let location = card.location ? card.location : ''
      let begin = new Date(dayjs(card.dates).format('YYYY-MM-DD') + 'T00:00:00')
      let stop = new Date(dayjs(card.dates).add(1, 'day').format('YYYY-MM-DD') + 'T00:00:00')
      this.$ics.addEvent(language, subject, description, location, begin, stop)
      this.$ics.download(t('calendar') + ' - ' + card.title)
      this.$ics.removeAllEvents()
    },
    toggleSeeOpen() {
      this.seeMoreOpen = !this.seeMoreOpen
    },
  },
}
</script>

<style lang="stylus" scoped>
.calendar-card
  display: flex
  align-items: flex-start
  padding-top: vw(10px)
  padding-bottom: vw(10px)

  .mobile &
    flex-direction: column
    gap: vw(8px)

  .calendar-add
    margin-right: vw(30px)
    padding: vw(4px) vw(12px)
    cursor: pointer

    .mobile &
      display: flex
      width: fit-content
      gap: vw(4px)

    .cal-tag-op
      display: flex
      align-items: center
      gap: vw(5px)

      .new-icon
        m-icon("new", 16)

      .time-icon
        m-icon("time-delay", 16)

      .update-icon
        m-icon("update", 16)

      div
        m-font-size(12, 16)
        color: $grey-dark

  .calendar-date
    display: flex
    width: 50px
    justify-content: space-between
    margin-right: vw(20px)
    
    .date-wrap
      display: flex
      flex-direction: column
      gap: vw(8px)

      .date
        m-font-size(16, 25)
        color: #000
        font-weight: 600
        
      .date-hour
        width: fit-content
        margin: auto
        m-font-size(13, 20)
        color: $grey-dark
        font-weight: 400

  .calendar-desc
    display: flex
    flex: 1 1 0%
    align-items: flex-start

    .icon-wrapper
      margin-right: vw(10px)

  .cal-inf
    .card-see-extra
      margin-top: vw(10px)
      margin-bottom: vw(5px)

      .mobile &
        margin-top: vw(4px)

  .pub-op-wrap
    display: flex
    gap: vw(10px)

  .pub-op
    m-font-size(12, 16)
    display: flex
    align-items: center
    color: $corporate_color
    font-weight: 400
    cursor: pointer

    &:not(:last-child)
      padding-right: vw(10px)
      border-right: 1px solid lightgrey

    &:hover
      text-decoration: underline

  .card-title
    m-font-size(16, 25)
    margin-bottom: vw(10px)
    color: #000
    font-weight: 400

  .card-subtitle
    m-font-size(14, 22)
    color: $grey
    font-weight: 300

  .calendar-url
    display: flex

    span
      m-font-size(14, 22)
      color: $corporate_color
      word-break: break-word
      font-weight: 300
      overflow-wrap: break-word

      &:hover
        text-decoration: underline

.c-pointer
  cursor: pointer
</style>